import { OptionData } from "components/DesignSystem/Combobox/Combobox";

export type RagStatus = "green" | "amber" | "red";

export const PERFORMANCE_SORT_OPTIONS: OptionData[] = [
  { value: "DSC", label: "High performing first" },
  { value: "ASC", label: "Low performing first" },
];

export const RATING_SORT_OPTIONS: OptionData[] = [
  { value: "DSC", label: "Highly rated first" },
  { value: "ASC", label: "Low rated first" },
];

export const chatRagStatus = (responseTimeHr: number): RagStatus => {
  if (responseTimeHr < 12) return "green";
  if (responseTimeHr <= 24) return "amber";
  return "red";
};

export const ticketRagStatus = (resolutionRate: number | null): RagStatus => {
  if (resolutionRate === null) return "amber";
  if (resolutionRate > 90) return "green";
  if (resolutionRate > 75) return "amber";
  return "red";
};

export const invoiceRagStatus = (count: number): RagStatus => {
  if (count < 10) return "green";
  if (count < 15) return "amber";
  return "red";
};

export const ratingRagStatus = (score: number): RagStatus => {
  if (score >= 4.2) return "green";
  if (score >= 3.5) return "amber";
  return "red";
};
